import {z} from "zod/v4";

export const deliveryServiceValidationScheme = z.string().nonempty();

